import styles from "./RevenueGraph.module.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Line } from "react-chartjs-2";
import { DASHBOARD_CHART_OPTIONS, TABLE_MIN_WIDTH } from "../../../../constant";
import CustomTabs from "../../../CommonComponents/CustomTabs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";
import { formatNumbers } from "../../../../utils/NumberFormat";
import { Spin } from "antd";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
export const options = {
  plugins: {
    title: {
      display: false,
      text: "Chart.js Bar Chart - Stacked",
    },
    legend: {
      display: false,
    },
    tooltip: {
      itemSort: function (a, b) {
        return b.datasetIndex - a.datasetIndex;
      },
      callbacks: {
        title: function (tooltipItem, data) {
          return tooltipItem[0]["label"] + " " + new Date().getFullYear();
        },
        label: function (context) {
          var label = context.dataset.label || "";
          return (
            label +
            " - $" +
            formatNumbers(context.raw)
          );
        },
      },
    },
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      stacked: true,
    },
    y: {
      stacked: false,
    },
  },
};

const labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const RevenueGraph = ({ setHeight, data }) => {
  const divRef = useRef(null);
  const [filter, setFilter] = React.useState("All");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, []);

  useEffect(() => {
    var clientHeight = divRef?.current?.height;

    if (width < TABLE_MIN_WIDTH) {
      setHeight(55 * 6);
    }
    setHeight(clientHeight ? clientHeight - 31 : 55 * 6);
  }, [divRef, divRef?.current, divRef?.current?.height, setHeight, width]);

  const lineData = useMemo(() => {
    let datasets = [];
    if (filter !== "Enterprise") {
      datasets.push({
        label: "Candidates",
        data: data?.monthlyRevenue?.professionalTotals,
        backgroundColor: "#0e2159",
        borderColor: "#0e2159",
      });
    }

    if (filter !== "Candidates") {
      datasets.push({
        label: "Enterprise",
        data: data?.monthlyRevenue?.enterpriseTotals,
        backgroundColor: "#a6dd50",
        borderColor: "#a6dd50",
      });
    }
    return {
      labels,
      datasets: datasets,
    };
  }, [filter,
    data?.monthlyRevenue?.professionalTotals,
    data?.monthlyRevenue?.enterpriseTotals,
  ]);

  return (
    <div className={styles.chart_wrap}>
      <div className={styles.chart_header}>
        <div className={styles.label}>Total revenue</div>
        <CustomTabs
          defaultValue={filter}
          onChange={(value) => setFilter(value)}
          options={DASHBOARD_CHART_OPTIONS}
        />
      </div>

      {data?.monthlyRevenue?.enterpriseTotals ? (
        <Line ref={divRef} options={options} data={lineData} />
      ) : (
        <div className={styles.loader_wrap}>
          <Spin />
        </div>
      )}
      <div className={styles.chart_footer}>
        *Enterprise is classified as 1 user
      </div>
    </div>
  );
};

export default RevenueGraph;
